import _ from "lodash";
import { isValidString } from "utils/misc";
import Methods from "./firestore/methods";

class Method {
  static COLLECTION = "methods";

  constructor(data = {}) {
    this.key = _.get(data, "key");
    this.name = _.get(data, "name");
    this.type = _.get(data, "type", "Other");
  }

  get category() {
    return this.type;
  }

  static async generic() {
    const methodsInstance = await Methods.getInstance();
    const allMethods = methodsInstance.getAllMethodsFlattened();

    // Return just the method names (strings) for autocomplete
    const methodNames = [];

    _.forEach(allMethods, (methodData) => {
      // Add the official name
      methodNames.push(methodData.officialName);

      // Add each alias
      _.forEach(methodData.aliases, (alias) => {
        methodNames.push(alias);
      });
    });

    return _.uniq(methodNames);
  }

  static async get(name) {
    if (!isValidString(name)) {
      return new Method();
    }

    const methodsInstance = await Methods.getInstance();

    // First, try to find the official name for this alias
    const officialName = methodsInstance.getOfficialMethodName(name);
    if (officialName) {
      const category = methodsInstance.getCategoryForMethod(name);
      return new Method({
        key: name,
        name: officialName,
        type: category,
      });
    }

    // If not found in predefined methods, create a custom method
    return new Method({ name: name });
  }

  // Helper method to get category for a method name
  static async getCategory(methodName) {
    if (!isValidString(methodName)) {
      return "Other";
    }

    const methodsInstance = await Methods.getInstance();
    return methodsInstance.getCategoryForMethod(methodName) || "Other";
  }

  // Helper method to get official name for an alias
  static async getOfficialName(alias) {
    if (!isValidString(alias)) {
      return alias;
    }

    const methodsInstance = await Methods.getInstance();
    return methodsInstance.getOfficialMethodName(alias) || alias;
  }

  get publicKey() {
    return this.name;
  }
}

export default Method;
